import { render, staticRenderFns } from "./PriceCaptions.vue?vue&type=template&id=4fea4d5c&"
import script from "./PriceCaptions.vue?vue&type=script&lang=js&"
export * from "./PriceCaptions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports